import React, { useRef, useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "./SelfieCapture.css";

const SelfieCapture = ({ show, handleClose, onCapture }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [selfiePreviewUrl, setSelfiePreviewUrl] = useState(null);
  const [stream, setStream] = useState(null);

  useEffect(() => {
    if (show) startCamera();
    else stopCamera();

    return () => stopCamera(); // Cleanup
  }, [show]);

  const startCamera = async () => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoRef.current.srcObject = mediaStream;
      setStream(mediaStream);
      await videoRef.current.play();
    } catch (err) {
      console.error("Error accessing camera:", err);
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }
    if (videoRef.current) videoRef.current.srcObject = null;
  };

  const captureSelfie = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageUrl = canvas.toDataURL("image/png");
    setSelfiePreviewUrl(imageUrl);
  };

  const handleRetake = () => {
    setSelfiePreviewUrl(null);
    startCamera();
  };

  const handleUsePhoto = () => {
    if (selfiePreviewUrl) {
      onCapture(selfiePreviewUrl); // send photo back to parent
      stopCamera();
      handleClose();
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => { stopCamera(); handleClose(); }}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Capture Selfie</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {!selfiePreviewUrl && (
          <video
            ref={videoRef}
            autoPlay
            style={{ width: "100%", maxWidth: "400px", borderRadius: "12px" }}
          />
        )}

        <canvas ref={canvasRef} style={{ display: "none" }} />

        {selfiePreviewUrl && (
          <img
            src={selfiePreviewUrl}
            alt="Selfie Preview"
            style={{ width: "100%", maxWidth: "400px", borderRadius: "12px" }}
          />
        )}

        <p className="mt-3">
          Please take a selfie with any Indian government ID (Aadhaar, PAN, voter ID, etc.)
        </p>
      </Modal.Body>
      <Modal.Footer>
        {!selfiePreviewUrl && (
          <>
           <Button 
  variant="" 
  onClick={() => { 
    stopCamera(); 
    handleClose(); 
  }}
  className="cancel-btn"
>
  Cancel
</Button>

         <Button 
  variant="" 
  onClick={captureSelfie} 
  disabled={!videoRef.current}
  className="selfie-btn"
>
  Take Photo
</Button>

          </>
        )}

        {selfiePreviewUrl && (
          <>
            <Button variant="secondary" onClick={() => { stopCamera(); handleClose(); }}>
              Cancel
            </Button>
            <Button variant="warning" onClick={handleRetake}>
              Retake
            </Button>
            <Button variant="success" onClick={handleUsePhoto}>
              Use Photo
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default SelfieCapture;
